export default "/images/javit.svg?7ef441da2fa497a80d36a9d2812dac5a";